import { z } from 'zod';
import { PhotoReportRecordSchema } from '../base/photoReport.js';
import { DocumatorServiceEventBaseSchema, documatorServiceEventType } from './service.js';
export const photoReportEventType = (eventName) => documatorServiceEventType('photoReport', eventName);
export const PhotoReportEventSchema = DocumatorServiceEventBaseSchema.merge(z.object({
    type: photoReportEventType(),
    photoReport: PhotoReportRecordSchema.and(z.unknown()),
}));
export const PhotoReportCompletedEventSchema = PhotoReportEventSchema.merge(z.object({
    type: photoReportEventType('completed'),
}));
